import { findObjectUseCase } from "../../../../usecases/object";
export const getAssignAirport = async (objects) => {
  let ids = objects.map((emp) => emp.id);

  const airportAssigned = await findObjectUseCase().execute("airport_assign", {
    include: ["assignRelation", "assignRelation.employee"],
  });

  const idSet = new Set(ids);
  const filteredEmployeeDuty = airportAssigned.filter((item) =>
    item.assignRelation?.some(
      (relation) => relation.employee && idSet.has(relation.employee.id)
    )
  );

  const result = {};

  for (const item of filteredEmployeeDuty) {
    const start = new Date(item.startDate);
    const end = new Date(item.endDate);
    const timeDiff = Math.abs(end - start);
    const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24)) + 1;

    for (const relation of item?.assignRelation ?? []) {
      const emp = relation?.employee;

      if (emp && ids.includes(emp.id)) {
        result[emp.id] = days;
      }
    }
  }

  return {
    result,
    filteredEmployeeDuty,
  };
};

export const getMonthIndex = (selectedDate) => {
  if (!selectedDate?.startDate) return;

  const start = new Date(selectedDate?.startDate);
  const month = start.getMonth();

  return 12 - month;
};
